module.exports = __webpack_public_path__ + "static/img/MM020-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/MM020-1.png
// module id = jIdq
// module chunks = 0